import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TodaysDate from '../shared/TodaysDate';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { UserRoles } from '../shared/enums';
import "./Home.css";

class Banner extends Component {
    displayName = Banner.name;

    constructor(props) {
        super(props);

        this.greeting = (new Date()).getHours() < 12 ? "Good Morning " : "Welcome ";

        this.state = {
            banner: { isChecked: false },
            bannerImg: "",
            url: "",
            selectedFile: "",
            load: false,
            isChecked: false
        };
    }

    componentDidMount = async (props) => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        this.setState({ load: true });
        const response = await fetch('api/Home/banner/', fetchConfig);
        if (response.ok) {
            let data = await response.json().then(json => json).catch(() => null);
            if (data !== null) {

                let banner = data;

                banner.isChecked = false;
                  
                this.setState({
                    bannerImg: "data: image/jpeg;base64," + data.imageData,
                    banner: banner
                });
            }
            else
            {
                let banner = {
                    bannerImg: "",
                    isChecked: false
                };

                this.setState({ banner: banner });
            }
            this.setState({ load: false });
        }
        else if (response.status === 401) {
            this.props.signOut();
        }
        else {
            console.log("Error getting banner: " + response.status);
        }
    };

    onChangeFile(event) {
        event.stopPropagation();
        event.preventDefault();
        var file = event.target.files[0];
        this.setState({ selectedFile: file });

        var banner = this.state.banner;
        banner.bannerImg = URL.createObjectURL(event.target.files[0]);

        this.setState({ bannerImg: banner.bannerImg, banner: banner });
        this.uploadFile(event.target.files[0]);
    }

    uploadFile(file) {
        let data = new FormData();
        data.append('image', file);

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json'
            },
            body: data
        };
        fetch('api/Home/banner/', fetchConfig)
            .then(response => {
                if (response.ok) {
                    console.log('Banner updated.');
                }
                else if (response.status === 401) {
                    this.props.signOut();
                }
                else {
                    console.log("Error updating banner: " + response.status);
                }
            })
            .catch(error => {
                console.log("Error in uploadFile.");
                console.log(error);
            });
    }

    bannerImageLoaded = () => {
        let button = document.querySelectorAll('.ogcBannerButton');
        if (button && button[0]) {
            button[0].classList.remove('hidden');
        }
    }

    setIsChecked = async () => {
        var banner = this.state.banner;
        banner.isChecked = !banner.isChecked;

        await this.setState({ banner });

        this.props.toggleAddToCopyHome('banner', banner);
    }

    render() {
        const imageBase64 = this.state.bannerImg;

        return (
            <div>
                <div className="banner-container">
                    {this.state.bannerImg !== "" &&
                        <img src={imageBase64} alt="" className="img-banner" onLoad={this.bannerImageLoaded} />
                    }
                    <div className="ogcBannerName">
                        {this.props.isCopyHome &&
                            <React.Fragment>
                                <label htmlFor="test" />
                                <label className="homeCheckbox">
                                <input type="checkbox" name="test" checked={this.state.banner.isChecked} onChange={this.setIsChecked} />
                                    <span />
                                </label>
                            </React.Fragment>
                        }
                        {this.greeting}<b>{this.props.auth.user.name || this.props.auth.user.userName}</b>!
                        <br />
                        (<TodaysDate />)           
                    </div>
                    {this.props.isAuthenticated && this.props.isEditHome && (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep) &&
                        <div>
                            {!this.props.isCopyHome &&
                                <React.Fragment>
                                    <button className="ogcBannerButton" onClick={() => { this.upload.click(); }}>
                                        Upload Banner Image
                                    </button>
                                    <input id="myInput"
                                        type="file"
                                        ref={(ref) => this.upload = ref}
                                        style={{ display: 'none' }}
                                        onChange={this.onChangeFile.bind(this)}
                                    />
                                </React.Fragment>
                            }                           
                        </div>
                    }      
                </div>
                {this.props.isAuthenticated && (this.props.userRole === UserRoles.GroupStoreBuyer || this.props.userRole === UserRoles.StoreBuyer) &&
                    <div>
                        <form action="/CreateSalesOrder" style={{ position: 'relative' }}>
                            <input className="ogcBannerButton hidden" type="submit" value="CREATE SALES ORDER" />
                        </form>
                    </div>
                }
                {this.props.isAuthenticated && !this.props.isEditHome && (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep) &&
                    <div>
                        <form action="/OrderGuide" style={{ position: 'relative' }}>
                            <input className="ogcBannerButton hidden" type="submit" value="CREATE ORDER GUIDE" />
                        </form>
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Banner));


// WEBPACK FOOTER //
// ./src/components/Home/Banner.js